export const PRINT_FORMAT = {
  HTML: 'html',
  RAW: 'raw',
};

/**
 * Phase 1: browser print from rendered HTML/CSS.
 * Phase 2: optional local helper consumes RAW jobs.
 */
export function createHtmlPrintJob(meta = {}) {
  return {
    format: PRINT_FORMAT.HTML,
    payload: { note: 'Render label in DOM; trigger window.print()' },
    meta,
  };
}

export function createRawPrintJobPlaceholder({ hint } = {}) {
  return {
    format: PRINT_FORMAT.RAW,
    payload: {
      bytesBase64: null,
      hint: hint || 'Reserved for EPL/PPLB via desktop agent',
    },
    meta: {},
  };
}
